<template>
  <div>
    <div
      v-for="(item, index) in bookingList"
      :key="item.orderId"
      class="row-item"
      @click="detailOnClick(item.orderId)"
    >
      <div
        :class="{
          'row-item-odd': index % 2 === 0,
          'row-item-even': index % 2 !== 0,
        }"
      >
        <div class="column-left">
          <div class="row-title">服務項目</div>
          <div class="row-content">{{ item.serviceName }}</div>
        </div>

        <div class="column-right">
          <div class="row-title">申請日期</div>
          <div class="row-content">{{ item.applyTime }}</div>
        </div>

        <div class="column-img">
          <img class="item-img" src="~@/assets/images/entry.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomListTable',
  props: {
    bookingList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
    },
  },
  methods: {
    detailOnClick(data) {
      this.$emit('input', data);
    },
  },
};
</script>

<style scoped>
.row-item {
  cursor: pointer;
}
.row-item-odd {
  display: flex;
  min-height: 69px;
  background: #f3f3f3;
}
.row-item-even {
  display: flex;
  min-height: 69px;
  background: #fff;
}
.row-title {
  display: flex;
  font-size: 12px;
  width: 100%;
}
.row-content {
  display: flex;
  font-size: 16px;
  margin-top: 5px;
  width: 100%;
}

.column-left {
  width: 45%;
  height: auto;
  padding-left: 12px;
  margin: auto;
}
.column-right {
  width: 50%;
  height: auto;
  margin: auto;
}
.column-img {
  width: 5%;
  margin: auto;
  margin-right: 10px;
}
</style>
